import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import {
    Docker,
    K8s, Linux,
    RealTimeServerless, SimplifyServerless, UnifyYourServerless, Windows
} from "../../components/v2/icons";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../components/v2/agent-integration";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import ProductTour from "../../components/v2/product/product-tour";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import '../../styles/scss/_faq-section.module.scss';

export default function ServerlessMonitoring() {
    const { t } = useTranslation("common");

    const featuresData = t('product.serverless-monitoring.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.serverless-monitoring.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.serverless-monitoring.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const cardWithIconData = t('product.serverless-monitoring.cardWithIcon', { returnObjects: true }) as any[]

    const productTourData = t('product.serverless-monitoring.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.serverless-monitoring.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.agentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={<h1>{t('product.serverless-monitoring.hero.title')} <span>{t('product.serverless-monitoring.hero.titleHighlight')}</span></h1>}
                                description={t('product.serverless-monitoring.hero.description')}
                                img={"/images/product/serverless-monitoring.png"} imgMobile={"/images/product/serverless-monitoring-mobile.webp"} imgAlt={t('product.serverless-monitoring.hero.imageAlt')} preloadImg hasActions={true} tips={t('product.hero.tips')}/>

            <section className={'mw-card-with-icon product-page'}>
                <div className={'container'}>
                    <h2>{t('product.serverless-monitoring.section.title')}</h2>
                    <p>{t('product.serverless-monitoring.section.description')}</p>
                    <div className={'card-items'}>
                        <div className={'d-flex card-items'}>
                            <CardWithIcon icon={<UnifyYourServerless />} title={cardWithIconData[0].title}
                                          description={cardWithIconData[0].description}/>
                            <CardWithIcon icon={<RealTimeServerless />} title={cardWithIconData[1].title}
                                          description={cardWithIconData[1].description}/>
                            <CardWithIcon icon={<SimplifyServerless />} title={cardWithIconData[2].title}
                                          description={cardWithIconData[2].description}/>

                        </div>
                    </div>
                </div>
            </section>

            <FeaturesMonitoring productFeatures={features} title={<h2>{t('product.serverless-monitoring.features.title')}</h2>} tourId={"serverless-tour"}/>

            <Testimonial/>

            <ProductTour tourSrc={"https://app.supademo.com/embed/clzi9as7d1kew9x772zuwojcd?embed_v=2"} title={productTourData.title} tourId={"serverless-tour"} description={productTourData.description}/>

            <AgentIntegration
                agentDeploy={agentDeploy}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.serverless-monitoring.agentIntegration.title"
                            components={{ highlight: <span className="text-gradient" /> }}
                        />
                    </h2>
                }
                description={agentIntegrationData.description}
            />

            <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.serverless-monitoring.faq.title')}</h2>
                    <p>{t('product.serverless-monitoring.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>

            {/*<BlogHomeTab postData={posts}/>*/}


        </>
    )
}